"use client";
import React from "react";
const RadioContext = React.createContext(null);
export const useRadioGroup = () => React.useContext(RadioContext);
export default RadioContext;
